<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="savePhoto()" autocomplete="off">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Upload de Foto</h4>

              <!-- Upload de Foto -->
              <div class="row mb-4">
                <div class="col-md-12">
                  <label class="d-block mb-2">Foto <span class="text-danger">*</span></label>
                  <input
                    ref="photo"
                    type="file"
                    name="photo"
                    accept="image/*"
                    @change="setImage"
                    style="display: none;"
                  />
                  <div class="text-center p-4 border rounded" style="background: #f8f9fa;">
                    <div v-if="photo.photo">
                      <img
                        :src="photo.photo"
                        class="img-fluid mb-3"
                        style="max-height: 300px; border-radius: 8px;"
                      >
                    </div>
                    <div v-else class="mb-3">
                      <i class="mdi mdi-cloud-upload" style="font-size: 64px; color: #ced4da;"></i>
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="$refs.photo.click()"
                    >
                      <i class="mdi mdi-camera"></i> {{ photo.photo ? 'Trocar Foto' : 'Escolher Foto' }}
                    </button>
                    <p class="text-muted mt-3 mb-0">Tamanho máximo: 2MB</p>
                  </div>
                  <div v-if="submitted && !photo.photo" class="text-danger mt-2">
                    A foto é obrigatória.
                  </div>
                </div>
              </div>

              <!-- Informações (Opcionais) -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="title">Título <small class="text-muted">(opcional)</small></label>
                    <input
                      id="title"
                      v-model="photo.title"
                      name="title"
                      type="text"
                      class="form-control"
                      placeholder="Ex: Momento de networking"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description">Descrição <small class="text-muted">(opcional)</small></label>
                    <textarea
                      id="description"
                      v-model="photo.description"
                      name="description"
                      rows="3"
                      class="form-control"
                      placeholder="Digite uma descrição para a foto..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="float-right">
                <button type="button" @click="cancelar()" class="btn btn-dark mr-4">
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary mr-1">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'Photo',
  page: {
    title: 'Foto',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      photo: {
        id: '',
        title: '',
        description: '',
        photo: '',
        binaryPhoto: null
      },
      submitted: false,
      title: 'Nova Foto',
      items: [
        {
          text: 'Fotos',
          href: '/photos'
        },
        {
          text: 'Nova Foto',
          active: true
        }
      ]
    }
  },
  mounted () {
    this.loadItem()
  },
  computed: {
    ...mapState('photos', { data: 'photo' })
  },
  methods: {
    ...mapActions('photos', {
      fetch: 'GetPhoto',
      postData: 'SavePhoto'
    }),
    cancelar () {
      this.$router.push({ name: 'site-photos' })
    },
    setImage (e) {
      const file = e.target.files[0]
      if (!file) return

      if (file.type.indexOf('image/') === -1) {
        errorMessage('Alerta: Por favor selecione uma imagem.')
        return
      }

      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        errorMessage('Alerta: Tamanho máximo 2MB!')
        return
      }

      this.photo.binaryPhoto = file

      const reader = new FileReader()
      reader.onload = (event) => {
        this.photo.photo = event.target.result
      }
      reader.readAsDataURL(file)
    },
    loadItem () {
      if (this.$route.params.id !== undefined) {
        let loader = this.$loading.show()
        this.items[1].text = 'Editar Foto'
        this.title = 'Editar Foto'
        this.fetch(this.$route.params.id)
          .then(() => {
            this.photo = Object.assign({}, this.data)
          }).then(() => {
            loader.hide()
          })
      }
    },
    async savePhoto () {
      this.submitted = true

      if (!this.photo.photo) {
        window.scroll(0, 0)
        return
      }

      let loader = this.$loading.show()
      window.scroll(0, 0)

      const formData = new FormData()
      formData.append('id', this.photo.id || '')
      formData.append('title', this.photo.title || '')
      formData.append('description', this.photo.description || '')

      if (this.photo.binaryPhoto) {
        formData.append('photo', this.photo.binaryPhoto, 'photo.jpg')
      }

      await this.postData(formData).then(res => {
        let message = 'Sucesso: Foto enviada com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.cancelar()
        loader.hide()
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        loader.hide()
      })
    }
  }
}
</script>
